module.exports = __webpack_public_path__ + "img/modal_ribbon_share.98d5044c.png";